import { api, useApi } from '../../configuration/api/apiHelper';
import {
  BrowseHandymanQuery,
  HandymanViewModel,
} from '../../configuration/api/apiSchema';

// Default page size for lazy loading
export const HANDYMAN_PAGE_SIZE = 10;

// Get Handyman list
export enum GET_HANDYMAN_LIST {
  REQUEST = 'GET_HANDYMAN_LIST_REQUEST',
  SUCCESS = 'GET_HANDYMAN_LIST_SUCCESS',
  FAILURE = 'GET_HANDYMAN_LIST_FAILURE',
}

// Load more handymen (for lazy loading)
export enum LOAD_MORE_HANDYMEN {
  REQUEST = 'LOAD_MORE_HANDYMEN_REQUEST',
  SUCCESS = 'LOAD_MORE_HANDYMEN_SUCCESS',
  FAILURE = 'LOAD_MORE_HANDYMEN_FAILURE',
}

// Reset handyman list
export const RESET_HANDYMAN_LIST = 'RESET_HANDYMAN_LIST';

export const getHandymanListRequest = () => {
  return {
    type: GET_HANDYMAN_LIST.REQUEST,
  };
};

export const getHandymanListRequestAction = () => ({
  type: GET_HANDYMAN_LIST.REQUEST,
});

export const getHandymanListSuccessAction = (
  handymanList: HandymanViewModel[],
  hasMore: boolean,
) => ({
  type: GET_HANDYMAN_LIST.SUCCESS,
  handymanList,
  hasMore,
});

export const getHandymanListFailureAction = (error: string) => ({
  type: GET_HANDYMAN_LIST.FAILURE,
  error,
});

export const loadMoreHandymenRequestAction = () => ({
  type: LOAD_MORE_HANDYMEN.REQUEST,
});

export const loadMoreHandymenSuccessAction = (
  handymanList: HandymanViewModel[],
  hasMore: boolean,
  page: number,
) => ({
  type: LOAD_MORE_HANDYMEN.SUCCESS,
  handymanList,
  hasMore,
  page,
});

export const loadMoreHandymenFailureAction = (error: string) => ({
  type: LOAD_MORE_HANDYMEN.FAILURE,
  error,
});

export const resetHandymanList = () => ({
  type: RESET_HANDYMAN_LIST,
});

export const getHandymanList = (query: BrowseHandymanQuery) => {
  return async (dispatch: any) => {
    dispatch(getHandymanListRequestAction());

    try {
      const queryWithPagination = {
        ...query,
        page: 1,
        pageSize: query.pageSize || HANDYMAN_PAGE_SIZE,
      };

      const response = await useApi(() =>
        api.browseHandyman.browseHandymanCreate(queryWithPagination),
      );

      if (response.result) {
        const hasMore =
          response.result.length >=
          (queryWithPagination.pageSize || HANDYMAN_PAGE_SIZE);
        console.log(
          'API RESULT BEFORE DISPATCH',
          response.result?.map((h: any) => ({
            id: h.id,
            rating: h.rating,
            reviewsCount: h.reviewsCount,
            fullName: h.fullName,
          })),
        );
        dispatch(getHandymanListSuccessAction(response.result, hasMore));
      } else {
        dispatch(getHandymanListFailureAction('Failed to fetch handyman list'));
      }
    } catch (error: any) {
      dispatch(
        getHandymanListFailureAction(error.message || 'An error occurred'),
      );
    }
  };
};

export const loadMoreHandymen = (query: BrowseHandymanQuery, page: number) => {
  return async (dispatch: any) => {
    dispatch(loadMoreHandymenRequestAction());

    try {
      const queryWithPagination = {
        ...query,
        page,
        pageSize: query.pageSize || HANDYMAN_PAGE_SIZE,
      };

      const response = await useApi(() =>
        api.browseHandyman.browseHandymanCreate(queryWithPagination),
      );

      if (response.result) {
        const hasMore =
          response.result.length >=
          (queryWithPagination.pageSize || HANDYMAN_PAGE_SIZE);
        dispatch(loadMoreHandymenSuccessAction(response.result, hasMore, page));
      } else {
        dispatch(
          loadMoreHandymenFailureAction('Failed to fetch more handymen'),
        );
      }
    } catch (error: any) {
      dispatch(
        loadMoreHandymenFailureAction(error.message || 'An error occurred'),
      );
    }
  };
};
